module.exports = __webpack_public_path__ + "img/ico32.fdfc6c39.jpg";